export default __webpack_public_path__ + "253c40edd6a87da43ad497c831fcd56c.svg";